import Minze, { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { Locale } from '../../../../modules/locale'
import { isMobile } from '../../../../modules/utils'

// TODO: Add loading state
export interface SearchTabItem {
  id: string
  title: {
    fr: string
    en: string
  }
  modalName: string
  tabContent: string
  total?: number | ''
}

export interface LvcSearchResultsTabs {
  items: string
  initialTabIndex: number
  loading?: boolean
  activeTabIndex: number
  selectedTab?: {
    id: string
    text?: string
    counter?: string | number
  }
}

export class LvcSearchResultsTabs extends MinzeElement {
  // Declare props to accept the `items` array dynamically
  attrs: Attrs = ['items', 'loading', ['initial-tab-index', 0]]
  static observedAttributes = ['items', 'loading']
  reactive: Reactive = [
    ['activeTabIndex', 0],
    'selectedTab',
    ['mobileSelectOpen', false],
    ['isMobile', isMobile()],
  ]
  handleWindowResize = () => {
    this.isMobile = isMobile()
  }
  onReady = () => {
    this.activeTabIndex = +this.initialTabIndex || 0
    this.handleSticky()
  }
  onRender = () => {
    this.selectedTab = {
      id: (JSON.parse(decodeURIComponent(this.items)) as SearchTabItem[])[this.activeTabIndex]?.id,
      text: (JSON.parse(decodeURIComponent(this.items)) as SearchTabItem[])[this.activeTabIndex]
        ?.title[Locale.language],
      counter: (JSON.parse(decodeURIComponent(this.items)) as SearchTabItem[])[this.activeTabIndex]
        ?.total,
    }
    const activeTabElement = this.select('.tab-title.active')
    if (activeTabElement) {
      activeTabElement.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      })
    }
  }
  handleDropdownClick(event: Event) {
    if (!event.target) return
    const target = event.target as HTMLElement
    const index = Number(target.getAttribute('data-index'))
    Minze.cast('lvc:search-tab-clicked', {
      modalName: (JSON.parse(decodeURIComponent(this.items)) as SearchTabItem[])[index].modalName,
    })
    this.mobileSelectOpen = false
    this.selectedTab = {
      id: (JSON.parse(decodeURIComponent(this.items)) as SearchTabItem[])[index].id,
      text: (JSON.parse(decodeURIComponent(this.items)) as SearchTabItem[])[index].title[
        Locale.language
      ],
      counter: (JSON.parse(decodeURIComponent(this.items)) as SearchTabItem[])[index].total,
    }
    this.activeTabIndex = index
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
  handleTabClick(event: Event) {
    if (!event.target) return
    const target = event.target as HTMLElement
    const index = Number(target.getAttribute('data-index'))
    Minze.cast('lvc:search-tab-clicked', {
      modalName: (JSON.parse(decodeURIComponent(this.items)) as SearchTabItem[])[index].modalName,
    })
    this.activeTabIndex = index
    this.scrollToTopOfTabContent()
    this.handleSticky()
  }

  handleTabPrev = () => {
    if (this.activeTabIndex === 0) return
    this.activeTabIndex -= 1
    this.scrollToTopOfTabContent()
    this.handleSticky()
  }

  handleTabNext = () => {
    const itemsLength = JSON.parse(decodeURIComponent(this.items)).length
    if (this.activeTabIndex === itemsLength - 1) return
    this.activeTabIndex += 1
    this.scrollToTopOfTabContent()
    this.handleSticky()
  }
  scrollToTopOfTabContent = () => {
    const tabs = this.select('.tabs')
    const tabTitles = this.select('.tab-titles')
    if (!tabs) return
    if (!tabTitles) return
    const sticky = tabTitles.classList.contains('stuck')
    const pos = tabs.getBoundingClientRect().top - 101
    if (sticky) {
      window.scrollTo({
        top: pos + window.scrollY,
        behavior: 'smooth',
      })
    }
  }
  handleSticky = () => {
    const tabTitles = this.select('.tab-titles')
    if (!tabTitles) return
    if (tabTitles.getBoundingClientRect().top <= 100) {
      tabTitles.classList.add('stuck')
    } else {
      tabTitles.classList.remove('stuck')
    }
  }
  handleScroll = (e: Event) => {
    if (!e) return
    this.handleSticky()
  }
  renderDownArrow = () => `
  <div class="dropdown-arrow">
      <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.684 0.345511C12.9971 0.522357 13.0939 0.897481 12.9002 1.18338C12.4503 1.84741 11.0725 3.33539 9.81171 4.6176C9.17181 5.26835 8.54375 5.88454 8.05152 6.34061C7.80664 6.56751 7.58795 6.7617 7.4148 6.90218C7.32971 6.97122 7.24381 7.03696 7.16457 7.08883C7.1258 7.11421 7.07468 7.14552 7.01663 7.17299L7.01544 7.17355C6.97928 7.19068 6.84472 7.25439 6.66662 7.25439C6.47652 7.25439 6.33326 7.18091 6.29999 7.16385L6.29719 7.16242C6.23979 7.13318 6.18865 7.09997 6.1495 7.07294C6.06913 7.01744 5.97975 6.94628 5.8892 6.87026C5.70516 6.71574 5.46946 6.50142 5.204 6.25184C4.67085 5.7506 3.98832 5.07939 3.30021 4.394C2.73361 3.82965 2.16745 3.26005 1.6735 2.76311C0.952369 2.03761 0.38516 1.46696 0.195261 1.29357C-0.065087 1.05587 -0.065087 0.670467 0.195261 0.432759C0.455608 0.195052 0.877715 0.195052 1.13806 0.432759C1.34906 0.625412 1.96583 1.24579 2.72204 2.00642C3.20833 2.49556 3.75228 3.0427 4.28307 3.57139C4.96995 4.25555 5.64157 4.91584 6.1605 5.40372C6.36002 5.5913 6.53271 5.74936 6.67263 5.87186C6.79246 5.76873 6.93679 5.63905 7.10182 5.48615C7.57447 5.04821 8.18759 4.44702 8.81958 3.80431C10.1026 2.49959 11.3914 1.0963 11.7663 0.542961C11.96 0.257067 12.3708 0.168665 12.684 0.345511Z" fill="white"/>
    </svg>
  </div>

  `

  renderMobile = () => /*html*/ `
    <div class="mobile-tabs">
      <div class="content">
      <div class="mobile-dropdown">
        <div class="dropdown-selected-item">
          <div class="dropdown-selected-item-text-wrapper ${this.selectedTab?.id === 'festivals' ? 'festival' : ''}">
            <div class="dropdown-selected-item-text ${this.selectedTab?.id === 'festivals' ? 'festival' : ''}">${this.selectedTab?.id === 'festivals' ? `<lvc-festival-icon></lvc-festival-icon>` : ''}${this.selectedTab?.text}</div>
            <div class="mobile-counter-text is-selected">${this.selectedTab?.counter ?? 0}</div>
          </div>
          ${this.renderDownArrow()}
        </div>
        <div class="mobile-dropdown-drawer">

        ${(JSON.parse(decodeURIComponent(this.items)) as SearchTabItem[])
          .map(
            (item, index) => `

            <div class="mobile-dropdown-link ${item.id === 'festivals' ? 'festival' : ''}" data-index=${index}>
              ${item.id === 'festivals' ? `<lvc-festival-icon></lvc-festival-icon>` : ''}
              ${item.title[Locale.language]}<sup class="mobile-counter-text">${item?.total ?? 0}</sup></div>
          `
          )
          .join('')}
          </div>
      </div>
      
      <div class="tab-content">
        ${(JSON.parse(decodeURIComponent(this.items)) as SearchTabItem[])
          .map(
            (item, index) => `
            <div class="tab-panel ${index === this.activeTabIndex ? 'active' : ''}" data-index="${index}" data-testid="${item.title.fr}">
              ${item.tabContent}
            </div>
          `
          )
          .join('')}
      </div>
      </div>
    </div>
  `
  renderDesktopTabs = () => /*html*/ `

    <div class="tabs padding-global">
      <div class="tab-titles">
        <div class="tab-titles-wrapper">
          ${(JSON.parse(decodeURIComponent(this.items)) as SearchTabItem[])
            .map(
              (item, index) => `
                <div class="${item.id === 'festivals' ? 'festival' : ''} tab-title ${index === this.activeTabIndex ? 'active' : ''}" data-index="${index}" data-testid="${item.title.fr}">
                  ${item.id === 'festivals' ? `<lvc-festival-icon></lvc-festival-icon>` : ''}
                  ${item?.title?.[Locale.language]}
                  <div class="tab-counter">${item?.total ?? 0}</div>
                </div>
              `
            )
            .join('')}
        </div>
      </div>
      <div class="tab-content">
        ${(JSON.parse(decodeURIComponent(this.items)) as SearchTabItem[])
          .map(
            (item, index) => `
            <div class="tab-panel ${index === this.activeTabIndex ? 'active' : ''}" data-index="${index}">
              ${item.tabContent}
            </div>
          `
          )
          .join('')}
      </div>
    </div>
  `
  // Dynamic rendering function
  // TODO: Change tab system to slider?
  html = () => `
    ${
      this.items && JSON.parse(decodeURIComponent(this.items)).length > 0
        ? `
    ${this.isMobile ? this.renderMobile() : this.renderDesktopTabs()}
    `
        : ''
    }
  `

  css = () => `
    .padding-global {
      padding-left: 6rem;
      padding-right: 6rem;
    }
    @media screen and (max-width: 991px) {
        .padding-global {
          padding-left: 4.5rem;
          padding-right: 4.5rem;
        }
      }
      @media screen and (max-width: 767px) {
        .padding-global {
          padding-left: 1rem;
          padding-right: 1rem;
        }
      }
    .mobile-dropdown-spacer {
      padding-top: 5rem;
    }
    .mobile-dropdown-drawer {
      position: absolute;
      display: ${this.mobileSelectOpen ? 'flex' : 'none'};
      gap: 1rem;
      flex-direction: column;
      padding: 1rem;
      background-color: #1E007D;
      height: auto;
      width: 100%;
      left: 0;
      right: 0;
      top: calc(100% + 4px);
      border-radius: 12px;

    }
    .mobile-dropdown {
      margin-left: 1rem;
      margin-right: 1rem;
      box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.25);
      position: sticky;
      -webkit-position: sticky;
      top: 1rem;
      z-index: 99;

      border-radius: 12px;
    }
    .mobile-counter-text {
      font-size: 0.75rem;
      margin-left: 4px;
    }
    .mobile-counter-text.is-selected {
      margin-left: 5px;
      margin-top: -17px;
    }
    .dropdown-arrow {
      transform: ${this.mobileSelectOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
    }
    .dropdown-selected-item {
      color: white;
      display:flex;
      align-items: center;
      justify-content: space-between;
      font-size: 1.5rem;
      cursor: pointer;
    }
    .dropdown-selected-item-text-wrapper {
      display: flex;
      align-items: center;
    }
    .dropdown-selected-item-text {
      display: flex;
      gap: 4px;
      text-wrap: wrap;
    }
    .dropdown-selected-item-text-wrapper.festival {
      color: #FF4600;
    }
    .dropdown-selected-item-text.festival {
      font-weight: 700;
    }
    .mobile-dropdown-link {
      display: flex;
      gap: 4px;
      cursor: pointer;
    }
    .mobile-dropdown-link.festival {
      color: #FF4600;
      font-weight: 700;
      font-size: 18px;
    }
    .mobile-tabs {
    
      display: none;
    }
    .mobile-content-item {
      padding-left: 1rem;
      padding-right: 1rem;
      overflow: hidden;
      position: relative;
    }

    .tab-titles-wrapper {
      padding: 0 3rem;
      display: flex;
      align-items: center;
      position: relative;
      gap: 2rem;
      overflow-x: auto;
      overflow-y: hidden;
      scrollbar-width: none;
    }

    lvc-geo-button {
      margin-top: -0.5rem;
      margin-left: auto;
    }

    .tab-nav {
      z-index: 2;
      position: absolute;
      cursor: pointer;
      border: 0;
      background: none;
      height: 50%;
      width: 60px;
      display: flex;
      align-items: center;
    }

    #tab-prev {
      justify-content: start;
      left: -8px;
      background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #97cdfd 75%);
    }

    #tab-prev > lvc-tab-prev-icon {
      opacity: ${this.activeTabIndex === 0 ? 0.35 : 1};
    }

    #tab-next {
      justify-content: end;
      right: 250px;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #7fdcfa 75%);
    }

    #tab-next > lvc-tab-next-icon {
      opacity: ${
        this.activeTabIndex === JSON.parse(decodeURIComponent(this.items))?.length - 1 ? 0.35 : 1
      };
    }

    .tab-titles {
      position: sticky;
      top: 16px;
      display: flex;
      align-items: center;
      gap: 56px;
      border-bottom: 1px solid #1E007D;
      z-index: 99;
    }
    .tab-titles.stuck {
      border-bottom: none;
      padding:0 0.5rem;
      color: white;
      background-color: #1E007D;
      box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.25);
      border-radius: 12px;
    }
    .tab-titles.stuck > lvc-geo-button {
      margin-top: 0;
    }
    .tab-titles.stuck > #tab-prev, .tab-titles.stuck > #tab-next {
      background: none;
      color: white;
    }
    .tab-titles.stuck > .tab-titles-wrapper > .tab-title.active {
      color: #BFF0FF;
      font-size: 18px;
    }
    .tab-titles.stuck > .tab-titles-wrapper > .tab-title {
      color: rgba(255, 255, 255, 0.5);
      font-size: 0.875rem;
    }
    .tab-title {
      font-weight: 500;
      color: #1E007D;
      white-space: nowrap;
      margin-bottom: -1px;
      font-size: 1rem;
      line-height: 21px;
      cursor: pointer;
      padding: 1rem 0;
      display: flex;
      gap: 3px;
      border: none;
      background: none;
      border-bottom: 4px solid transparent;
      transition: border-bottom 0.2s;
    }
    .tab-title.festival {
      font-size: 18px;
      font-weight: 700;
      color: #FF4600;
    }
    lvc-festival-icon {
      width: 18px;
      height: 18px;
      animation: 1.2s infinite ease-out pulse;
    }
    .tab-title:hover {
      border-bottom: 4px solid rgba(30, 0, 125, 0.5);
    }

    .tab-counter {
      line-height: 1.2;
      font-weight: 500;
      font-size: 0.75rem;
    }

    .tab-title.active {
      border-bottom: 4px solid #1E007D;
    }

    .tab-content {
      margin-top: 4rem;
    }

    .tab-panel {
      display: none;
    }

    .tab-panel.active {
      display: block;
    }
    .mobile-dropdown {
      padding: 20px;
      background-color: #1E007D;
      color: white;
    }
    .mobile-geo-button {
        display: none;
      }
    @media only screen and (max-width: 991px) {
      
      .mobile-tabs {
        display: block;
      }
      .tabs {
        display: none;
      }
      .dropdown-selected-item {
        font-size: 1.25rem;
      }
      .mobile-geo-button {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 2rem;
        margin-bottom: 1.5rem;
      }
    }
    @keyframes pulse {
      0%,100% {
        scale: 1.0;
      }
      50% {
        scale: 1.2
      }
    }
  `

  eventListeners?: EventListeners = [
    ['#tab-prev', 'click', this.handleTabPrev],
    ['#tab-next', 'click', this.handleTabNext],
    ['.tab-title', 'click', e => this.handleTabClick(e)],
    ['.mobile-dropdown-link', 'click', e => this.handleDropdownClick(e)],
    ['.dropdown-selected-item', 'click', e => (this.mobileSelectOpen = !this.mobileSelectOpen)],
    [window, 'resize', this.handleWindowResize],
    [window, 'scroll', this.handleScroll],
    [window, 'lvc:search-pagination-event', e => this.scrollToTopOfTabContent()],
  ]
}
